module.exports = "<div class=\"form-group has-feedback\">\r\n    <label class=\"col-sm-4 control-label\">{{label}}</label>\r\n    <div class=\"col-sm-8\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/form/form-group-content/form-group-content.component.html
// module id = ./src/app/shared/components/form/form-group-content/form-group-content.component.html
// module chunks = main